import React, { Component } from 'react';
import SecureLayout from '../../../templates/secure';
import {NavLink} from 'react-router-dom';
import _ from 'lodash';

class VersionsAdd extends Component{
	render(){
		const {versions} =this.props;
		let vc = _.find(versions.permissions, (o) => {return o==='Create'});
		return (
			vc ?
				<p>
					<NavLink to={`/versiones/crear`} className="button is-small is-inm-purple">{'Agregar versión'}</NavLink>
				</p>:''
		)
	}
}

export default SecureLayout(VersionsAdd);


// WEBPACK FOOTER //
// ./src/elements/versions/widget/versions_add.jsx